import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export function TimeoutProvider({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const intervalRef = useRef();

    useEffect(() => {
        if (exemptedRoutes.includes(location.pathname)) return;

        // Function to clear cookies and redirect
        const handleTimeout = () => {
            document.cookie = "PDATokenStage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie = "PDAUserStage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            toast.error('Session expired. Please log in again.');
            navigate('/login');
        };

        // Function to start the interval
        const startInterval = () => {
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(() => {
                handleTimeout();
            }, 43200000); // 12 hours = 12 * 60 * 60 * 1000 ms
        };

        // Start interval on mount
        startInterval();

        // Cleanup function
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [navigate, location.pathname]);

    return children;
}

const exemptedRoutes = ['/login', '/resetPassword', '/resetPassword/:ResetGuid'];